import { render } from "./learningTab.vue?vue&type=template&id=be668d62"
import script from "./learningTab.vue?vue&type=script&lang=js"
export * from "./learningTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__